import { render, staticRenderFns } from "./RatingReport.vue?vue&type=template&id=ebfe18b8&scoped=true&"
import script from "./RatingReport.vue?vue&type=script&lang=js&"
export * from "./RatingReport.vue?vue&type=script&lang=js&"
import style0 from "./RatingReport.vue?vue&type=style&index=0&id=ebfe18b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfe18b8",
  null
  
)

export default component.exports